import { CdkDragDrop, copyArrayItem, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { OpenDialogInConstructionComponent } from 'app/components/dialog/open-dialog-in-construction/open-dialog-in-construction.component';
import { InfosUser } from 'app/shared/models/class/auth/infosUser';
import { SessionByClub } from 'app/shared/models/class/club/club';
import { SessionRessource, SessionTrainee } from 'app/shared/models/class/planing/planing';
import { ClubRessource } from 'app/shared/models/class/resource/resource';
import { Trainee } from 'app/shared/models/class/trainee/trainee';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { ClubService } from 'app/shared/services/club/club.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { PdfService } from 'app/shared/services/pdf/pdf.service';
import { PlaningService } from 'app/shared/services/planing/planing.service';
import { ReportService } from 'app/shared/services/report/report.service';
import { TooltipService } from 'app/shared/services/tooltip/tooltip.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-admin-planning',
  templateUrl: './admin-planning.component.html',
  styleUrls: ['./admin-planning.component.scss']
})
export class AdminPlanningComponent implements OnInit {

  clubCode: string;
  userConnected: InfosUser;
  bookingSessions: SessionByClub[] = [];
  bookingSessionsOverview: SessionByClub[] = [];

  myControlSessionFirst = new UntypedFormControl();
  filteredOptionsSessionFirst: Observable<SessionByClub[]>;
  sessionFirstFiltered: SessionByClub[];
  showSessionSelected = true;

  myControlSessionSecond = new UntypedFormControl();
  filteredOptionsSessionSecond: Observable<SessionByClub[]>;
  sessionSecondFiltered: SessionByClub[];
  showSessionCompare = true;

  sessionSelected: SessionByClub;
  sessionToCompare: SessionByClub = null;
  resources: ClubRessource[] = [];
  resourceSession: ClubRessource[] = [];
  valueInputFirst = '';

  keySessionSelected = 0;
  keySessionCompare = 0;
  color: ThemePalette = 'primary';
  traineesSessionSelected: Trainee[] = [];
  traineesSessionCompare: Trainee[] = [];
  valueInputSecond = '';

  keysFilter = ['offerName', 'dateLib', 'trainees'];
  bookingSessionsToCompare: SessionByClub[];
  movetrainee: SessionTrainee;

  filterSessionsByOffer = true;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private clubService: ClubService,
    private uiService: UiService,
    private tooltip: TooltipService,
    private planingsService: PlaningService,
    private dialog: MatDialog,
    private router: Router,
    private faIconService: FaiconService,
    private pdfService: PdfService,
    private reportService: ReportService

  ) { }

  ngOnInit(): void {
    this.initComponent();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  drop(event: CdkDragDrop<any[]>, copy: boolean = false) {
    const trainee = event.previousContainer.data[event.previousIndex];
    const { sub: userKey } = this.authService.getDecodedToken();

    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      switch (copy) {
        case false:
          if (this.sessionToCompare) {
            let canTransfer = true;

            if (event.container.id === "session2") {
              if (this.sessionToCompare?.trainees) {
                if (this.sessionToCompare?.trainees?.length >= this.sessionToCompare.quantity) {
                  canTransfer = false;
                }
              }
            }

            if (canTransfer) {

              transferArrayItem(
                event.previousContainer.data,
                event.container.data,
                event.previousIndex,
                event.currentIndex,
              );

              this.resources = [...new Set(this.resources)];
              this.assignRessource();


              const { sessionKey: sessionKeySessionSelected } = this.sessionSelected;
              const { sessionKey: sessionKeySessionToCompare } = this.sessionToCompare;
              const { sessionTraineeKey } = trainee;

              const movetrainee = {
                session1: new SessionTrainee(sessionKeySessionSelected, sessionKeySessionToCompare, sessionTraineeKey, +userKey),
                session2: new SessionTrainee(sessionKeySessionToCompare, sessionKeySessionSelected, sessionTraineeKey, +userKey)
              };

              this.movetrainee = movetrainee[event.previousContainer.id];
              this.assignTrainees(this.movetrainee);
            } else {
              this.uiService.showSnackbar('Il y a trop de stagiaires pour cette session', false);
            }
          } else {
            this.uiService.showSnackbar('Veuillez sélectionner une session 2', false);
          }


          break;

        case true:
          const indexResource = this.resourceSession.findIndex(r => r.clubRessourceKey === event.item.data.clubRessourceKey) || null;

          if (indexResource === -1 || !indexResource) {
            copyArrayItem(
              event.previousContainer.data,
              event.container.data,
              event.previousIndex,
              event.currentIndex
            );
            this.assignRessource();

            this.resources = Array.from(new Set(this.resources.map(a => a.clubRessourceKey)))
              .map(key => {
                return this.resources.find(a => a.clubRessourceKey === key);
              });

          } else {
            this.uiService.showSnackbar('La ressource est déjà assignée à la session');
          }

          break;

        default:
          break;
      }
    }
  }

  changeValueInput(filterValue: string, session: string) {
    switch (session) {
      case 'session1':
        this.sessionFirstFiltered = [];
        this.valueInputFirst = filterValue.trim().toLocaleLowerCase();
        this.sessionFirstFiltered = [...this.bookingSessions.filter(b => {
          const keyTofilter = [b.dateLib, b.offerName, b.offerKey];
          // if (b.trainees) {
          //   keyTofilter.push(JSON.stringify(b.trainees).toLocaleLowerCase());
          // }
          return keyTofilter.join('§').toLocaleLowerCase().includes(this.valueInputFirst);
        })];
        break;

      case 'session2':
        this.sessionSecondFiltered = [];
        this.valueInputSecond = filterValue.trim().toLocaleLowerCase();
        this.sessionSecondFiltered = [...this.bookingSessionsToCompare.filter(b => {
          const keyTofilter = [b.dateLib, b.offerName, b.offerKey];
          // if (b.trainees) {
          //   keyTofilter.push(JSON.stringify(b.trainees).toLocaleLowerCase());
          // }
          return keyTofilter.join('§').toLocaleLowerCase().includes(this.valueInputSecond);
        })];
        break;

      default:
        break;
    }
  }
  changeSessionSelected(key: number, session: SessionByClub): void {
    this.showSessionSelected = !this.showSessionSelected;

    this.sessionSelected === session ?
      this.sessionSelected = null :
      this.sessionSelected = session;

    this.keySessionSelected = key;
    this.traineesSessionSelected = session.trainees;
    this.resourceSession = session.ressources ?? [];
    if (!this.filterSessionsByOffer) {
      this.bookingSessionsToCompare = [...this.bookingSessions.filter(s => s.sessionKey !== this.keySessionSelected)];
    } else {
      this.bookingSessionsToCompare = [...this.bookingSessions.filter(s => s.sessionKey !== this.keySessionSelected && s.offerName === session.offerName)];
    }
    // this.bookingSessionsToCompare = [...this.bookingSessions.filter(s => s.offerName === session.offerName)];

    if (this.sessionSelected === this.sessionToCompare) {
      this.sessionToCompare = null;
      this.keySessionCompare = 0;

    }
    this.traineesSessionCompare = [];
    setTimeout(() => {
      this.showSessionSelected = !this.showSessionSelected;
    }, 500);

  }

  changeSessionToCompare(key: number, session: SessionByClub): void {
    this.showSessionCompare = !this.showSessionCompare;

    this.sessionToCompare === session ?
      this.sessionToCompare = null :
      this.sessionToCompare = session;

    this.keySessionCompare = this.sessionToCompare ? key : 0;
    this.traineesSessionCompare = session.trainees || [];
    if (!this.filterSessionsByOffer) {
      this.bookingSessionsToCompare = [...this.bookingSessions.filter(s => s.sessionKey !== this.keySessionSelected)];
    } else {
      this.bookingSessionsToCompare = [...this.bookingSessions.filter(s => s.sessionKey !== this.keySessionSelected && s.offerName === session.offerName)];
    }

    setTimeout(() => {
      this.showSessionCompare = !this.showSessionCompare;
    }, 500);
  }

  resetSearch(session: string): void {
    switch (session) {
      case 'session1':
        this.myControlSessionFirst.reset();
        this.valueInputFirst = '';
        this.sessionFirstFiltered = [];
        break;

      case 'session2':
        this.myControlSessionSecond.reset();
        this.valueInputSecond = '';
        this.sessionSecondFiltered = [];
        break;

      default:
        break;
    }
  }

  getTooltip(value: string): string {
    return this.tooltip.getTooltip(value);
  }

  openDialogInContruction(text: string) {
    this.dialog.open(OpenDialogInConstructionComponent, {
      data: {
        text: text
      },
      height: '50%',
      width: '50%'
    });
  }

  //TODO redirection ne fonctionne pas
  goCounter(traineeKey: number, sess: string): void {
    const session = sess === 'session1' ? this.sessionSelected : this.sessionToCompare;
    const queryParams = {
      club: { offerName: session.offerName, traineeKey },
      admin: { offerName: session.offerName, traineeKey, clubCode: this.clubCode }
    };

    this.router.navigate(['/admin/counter'], { queryParams: queryParams[this.userConnected.role] });
  }

  getPdfSession(): void {
    this.pdfService.getPdfSession(this.sessionSelected.sessionKey).subscribe({
      next: blob => {
        const data = window.URL.createObjectURL(<any>blob.body);
        const anchor = document.createElement('a');
        const date = new Date();
        const time = date.getFullYear() + ('0' + (date.getMonth() + 1)).slice(-2) + ('0' + date.getDate()).slice(-2) + ('0' + date.getHours()).slice(-2) + ('0' + date.getMinutes()).slice(-2) + ('0' + date.getSeconds()).slice(-2);
        anchor.href = data;
        anchor.download = `NPHDF-${date.getFullYear()}-${this.sessionSelected.dateLib}-${time}.pdf`;
        anchor.click();
        setTimeout(() => {
          window.URL.revokeObjectURL(data);
        }, 100);
      }
    });
  }

  getExcelSession(): void {
    this.reportService.getReportSession(this.sessionSelected.sessionKey).subscribe();
  }

  private assignRessource(): void {
    const ressourcesKey = this.resourceSession.map(r => r.clubRessourceKey);
    const updateRessources = new SessionRessource(this.sessionSelected.sessionKey, ressourcesKey);

    this.planingsService.assignRessource(updateRessources).subscribe({
      next: () => { }
    });
  }

  private assignTrainees(updateTrainees: SessionTrainee): void {
    this.planingsService.assignTrainee(updateTrainees).subscribe({
      next: (sessionFromApi) => {
        this.refreshSessionsAfterUpdate(sessionFromApi);
      }
    });
  }

  refreshSessionsAfterUpdate(sessionFromApi) {
    this.bookingSessions = this.bookingSessions?.map(bookingSession => {
      if (bookingSession.sessionKey === sessionFromApi[0].sessionKey) {
        return sessionFromApi[0];
      } else if (bookingSession.sessionKey === sessionFromApi[1].sessionKey) {
        return sessionFromApi[1];
      }

      return bookingSession;
    })

    this.sessionFirstFiltered = this.sessionFirstFiltered?.map(bookingSession => {
      if (bookingSession.sessionKey === sessionFromApi[0].sessionKey) {
        return sessionFromApi[0];
      } else if (bookingSession.sessionKey === sessionFromApi[1].sessionKey) {
        return sessionFromApi[1];
      }

      return bookingSession;
    })

    this.bookingSessionsToCompare = this.bookingSessionsToCompare?.map(bookingSession => {
      if (bookingSession.sessionKey === sessionFromApi[0].sessionKey) {
        return sessionFromApi[0];
      } else if (bookingSession.sessionKey === sessionFromApi[1].sessionKey) {
        return sessionFromApi[1];
      }

      return bookingSession;
    })

    this.sessionSecondFiltered = this.sessionSecondFiltered?.map(bookingSession => {
      if (bookingSession.sessionKey === sessionFromApi[0].sessionKey) {
        return sessionFromApi[0];
      } else if (bookingSession.sessionKey === sessionFromApi[1].sessionKey) {
        return sessionFromApi[1];
      }

      return bookingSession;
    })
  }


  private getSessionsByClub(clubCode: string): void {
    this.clubService.getSessionsByClub(clubCode).subscribe({
      next: bookingSessions => {
        this.bookingSessions = [...bookingSessions];
        this.sessionSelected = this.bookingSessions[0];
        this.resourceSession = this.bookingSessions[0].ressources || [];
        this.keySessionSelected = this.sessionSelected.sessionKey;
        if (!this.filterSessionsByOffer) {
          this.bookingSessionsToCompare = [...this.bookingSessions.filter(s => s.sessionKey !== this.keySessionSelected)];
        } else {
          this.bookingSessionsToCompare = [...this.bookingSessions.filter(s => s.sessionKey !== this.keySessionSelected && s.offerName === this.sessionSelected.offerName)];
        }
        this.traineesSessionSelected = this.sessionSelected.trainees || [];
      }
    });
  }

  private getResourceClub(clubCode: string): void {
    this.clubService.getAllRessourceByClub(clubCode).subscribe({
      next: resource => this.resources = resource
    });
  }

  private initComponent(): void {
    this.userConnected = this.authService.getDecodedToken();
    this.clubCode = this.route.snapshot.queryParams.clubCode && this.userConnected.role === 'admin' ?
      this.route.snapshot.queryParams.clubCode : this.userConnected.club_code;
    this.getSessionsByClub(this.clubCode);
    this.getResourceClub(this.clubCode);
  }

  filterSessionsSecondByOffer(event) {
    this.filterSessionsByOffer = event.checked;
    if (!this.filterSessionsByOffer) {
      this.bookingSessionsToCompare = [...this.bookingSessions.filter(s => s.sessionKey !== this.keySessionSelected)];
    } else {
      this.bookingSessionsToCompare = [...this.bookingSessions.filter(s => s.sessionKey !== this.keySessionSelected && s.offerName === this.sessionSelected.offerName)];
    }
  }

}
